import type { Organization } from "~care/types";

/*
 * Takes an Organization (which contains a list of attributes)
 * and returns its local name, i.e. Austin, Westlake Hills
 * This is usually the colloquial representation of a service area.
 */
export function organizationLocalName(
  organization?: Pick<Organization, "attributes" | "offices">,
): string | null | undefined {
  if (!organization) return null;

  const nameAttribute = organization.attributes.find(
    (attribute) => attribute.typeName === "Name",
  );

  if (nameAttribute?.value === "Home Instead") {
    if (organization.offices && organization.offices.length > 0) {
      // Just default to the first office for naming purposes. Often there's only one.
      const firstOffice = organization.offices[0];
      // Ensure city and stateProvince are present in the first office
      if (firstOffice && firstOffice.city && firstOffice.stateProvince) {
        return `${firstOffice.city}, ${firstOffice.stateProvince}`;
      }
    }
    // Fallback if "Home Instead" but no office data or city/state missing
    return "Home Instead";
  }

  // Return the original name attribute value if it's not "Home Instead" or if no name attribute found
  return nameAttribute?.value;
}
